import { Eyebrow, Reveal } from "@/components/ui-bits";

const ITEMS = [
  "RECURRING FREIGHT",
  "TIME-CRITICAL SHIPMENTS",
  "PALLETIZED FREIGHT",
  "WHITE-GLOVE DELIVERIES",
  "COMMERCIAL & INDUSTRIAL FREIGHT",
  "INSIDE DELIVERY",
];

const Capabilities = () => {
  return (
    <section data-testid="capabilities-section" aria-labelledby="capabilities-heading" className="bg-white pb-16 pt-4 sm:pb-20 sm:pt-6 lg:pb-24 lg:pt-8">
      <div className="container-30 grid gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <Eyebrow>Our Capabilities</Eyebrow>
          <h2
            id="capabilities-heading"
            data-testid="capabilities-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl"
          >
            BUILT FOR DEMANDING FREIGHT REQUIREMENTS
          </h2>
          <p className="mt-6 text-base font-medium leading-relaxed text-[#5f666d] sm:text-lg">
            Reliability, responsiveness and flexible capacity — built into every shipment.
          </p>
        </Reveal>
        <div className="lg:col-span-7">
          <Reveal>
            <ul className="grid gap-4 sm:grid-cols-2" data-testid="capabilities-list">
              {ITEMS.map((item, i) => (
                <li
                  key={item}
                  data-testid={`capability-item-${i + 1}`}
                  className="flex items-center gap-4 border border-[#191c1e]/15 bg-white px-5 py-5 transition-all duration-200 hover:-translate-y-0.5 hover:border-[#ff6a00] hover:shadow-[0_14px_28px_-18px_rgba(25,28,30,0.4)]"
                >
                  <span className="block h-2 w-2 shrink-0 bg-[#ff6a00]" aria-hidden="true" />
                  <span className="text-base font-bold tracking-[0.1em] text-[#191c1e]">{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
